<template>
    <v-container fluid>
        <v-row class="pt-2" justify="center" align="center">
            <v-col>
                <h1 class="text-center">Resume</h1>
            </v-col>
        </v-row>
        <v-card
            class="mx-auto justify-center pt-2 pb-2"
            flat
        >
            <v-row justify="center" align="center">
                <v-col
                    cols="12"
                    md="6"
                >
                  <a href="./Russell_resume_summer20.pdf" target="_blank">
                    <v-card-title class="justify-center" v-text=item.headline>
                    </v-card-title>
                  </a>
                </v-col>  
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
// import pdf from "/Users/tuongdo/Documents/GitHub/rr-personal-website/rr-website/public/Russell_resume_summer20.pdf"

export default {
    name: "Resume",
    data: () => ({
        item: {
            headline: "View Full PDF Here",
        }
    })
}
</script>

<style lang="css" scoped>
.v-card {
    padding-top: 2%;
}
</style>